/**
 * Default / fallback content for service pages (matches DB seed).
 * Used when CMS API is unavailable; after seeding, admin + DB are the source of truth.
 */
import seedPages from './service-pages-seed.json';

export const SERVICE_PAGE_SLUGS = seedPages.map((p) => p.slug);

export function getServicePageDefaults(slug) {
  const page = seedPages.find((p) => p.slug === slug);
  if (!page) return {};
  return {
    title: page.title,
    subtitle: page.subtitle,
    introTitle: page.introTitle,
    introText: page.introText,
    bodyHtml: page.bodyHtml,
  };
}

export default seedPages;
